export default __webpack_public_path__ + "static/media/fa-brands-400.607a7785.eot";